module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAwCAYAAAALiLqjAAABFElEQVRYhe2WvQ3CMBBGH4gBoE1DRoANGIERqLIGoaOkTsMIMAASbABMQNJRZgMosJUQOTkT/hTwk6zE9p0/+c6yD5pOqzgQBEG+6wN7oFvinwJDINYDURTdGXQMTmNgoP77wBEYlQjsgCmQqP4BWOcN2ganFXBRzRZtvypOmHYAMFNfn1uIysRSYEIWotBWQBMDPcGmElOIXsrbBaQQhZSfIM0OQ+xtBZbAVrCJqyYlgYTsjNfC5QD+Pgf5m1WTAgtbAWkHJ7KbUreT7eIg7+CoWm2+koMDjz02Rd9qAc/zhjUXN9L89+DzSZ5vzvmuz4N1kSiAq4ssBTQxri4S5kPcm/yMsw0uByJfz4Gri36gLmo+Vx9bXaH3gTc3AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/left2.png
// module id = sJOB
// module chunks = 1